import styled from 'styled-components';

import { ResponsiveContainer, TopBar } from '../../atoms';

export type InitAppPageProps = {
	body: JSX.Element;
	testID: string;
	title: string;
	topBarHeaderLeftComponent?: JSX.Element | null;
};

/**
 * Generic Page to handle App init layout.
 * @param {PageContainerProps} props - Component's props
 */
export const InitAppPage = ({ body, testID, title, topBarHeaderLeftComponent = null }: InitAppPageProps) => {
	return (
		<>
			<TopBar headerLeft={topBarHeaderLeftComponent} testID={testID} title={title} variant="subpage" />
			<S.Container>
				<ResponsiveContainer $variant="subpage">{body}</ResponsiveContainer>
			</S.Container>
		</>
	);
};

namespace S {
	export const Container = styled.div`
		display: flex;
		background-color: ${({ theme }) => theme.colors.backgrounds.main.screen};
		flex-direction: row;
		justify-content: center;
		min-height: calc(100vh - 64px);

		@supports (min-height: calc(100svh - 64px)) {
			min-height: calc(100svh - 64px);
		}

		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			align-items: center;
			flex-direction: column;
			justify-content: flex-start;
			padding-bottom: 0px;
		}
	`;
}
